import '../styles/PageGlobal.css';
import './FournisseurListPage.css';
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ReferenceButton from '../components/ReferenceButton';
import { FournisseurService } from '../services/FournisseurService.js';

export default function FournisseurListPage() {
  const navigate = useNavigate();
  const [fournisseurs, setFournisseurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFournisseurs = useCallback(async () => {
    const service = new FournisseurService();
    setLoading(true);
    try {
      const data = await service.getAllFournisseurs();
      setFournisseurs(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchFournisseurs(); }, [fetchFournisseurs]);

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer ce fournisseur ?")) return;
    try {
      await new FournisseurService().deleteFournisseur(id);
      fetchFournisseurs();
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div>Chargement…</div>;
  if (error) return <div className="fournisseur-error">{error}</div>;
 console.log("🔍 Fournisseurs dans le state:", fournisseurs);
  console.log("🔍 Premier item:", fournisseurs[0]);

  return (
    <div className="containerMain fournisseur-container">
      <h1 className="fournisseur-title">Liste des Fournisseurs</h1>
      <div className="fournisseur-table-wrapper">
        <table className="fournisseur-table">
          <thead>
            <tr>
              <th>N°</th><th>Société 1</th><th>Société 2</th><th>Adresse 1</th>
              <th>Code postal</th><th>Ville</th><th>Pays</th><th>SIRET</th><th>Action</th>
            </tr>
          </thead>
          <tbody>
            {fournisseurs.map((f, idx) => (
              <tr key={f.id}>
                <td>{idx + 1}</td>
                <td>{f.societe1 || ''}</td><td>{f.societe2 || ''}</td>
                <td>{f.adresse1 || ''}</td><td>{f.codePostal || ''}</td>
                <td>{f.ville || ''}</td><td>{f.pays || ''}</td><td>{f.siret || ''}</td>
                <td className="fournisseur-action-cell">
                  <button className="fournisseur-btn fournisseur-btn-blue" onClick={() => navigate(`/fournisseur_edit/${f.id}`)}>Edit</button>
                  <button className="fournisseur-btn fournisseur-btn-red" onClick={() => handleDelete(f.id)}>Supprimer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="fournisseur-bottom-actions">
        <ReferenceButton to="/fournisseur_new">+ Créer un fournisseur</ReferenceButton>
      </div>
    </div>
  );
}